// Default sort order followed. Other keys should be displayed after these.
const MSPlanDetailsSortOrder = ['Part A', 'Part B', 'Parts A & B']

export default {
  MSPlanDetailsSortOrder,
}
